import { render, staticRenderFns } from "./DocumentosCliente.vue?vue&type=template&id=143974de&"
import script from "./DocumentosCliente.vue?vue&type=script&lang=js&"
export * from "./DocumentosCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports